module.exports = __webpack_public_path__ + "static/img/6.b2c8554.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/6.jpg
// module id = vli4
// module chunks = 1